(function () {
    function parseAttr(el, name) {
        try { return JSON.parse(el.getAttribute(name)); } catch (e) { return null; }
    }

    // walk up until we find the option picker that belongs to this block
    function pickerFor(el) {
        var node = el.parentElement;
        while (node) {
            var p = node.querySelector('.halo-productOptions');
            if (p) return p;
            node = node.parentElement;
        }
        return null;
    }

    function selectedValues(picker) {
        var values = [];
        picker.querySelectorAll('[data-option-index]').forEach(function (box) {
            var i = parseInt(box.getAttribute('data-option-index'), 10);
            var select = box.querySelector('select');
            var radio = box.querySelector('input[type="radio"]:checked');
            values[i] = select ? select.value : (radio ? radio.value : null);
        });
        return values.length ? values : null;
    }

    function indexFor(parentNames, optionName, role) {
        var target = (optionName || '').toLowerCase();
        var exact = parentNames.indexOf(target);
        if (exact > -1) return exact;

        for (var i = 0; i < parentNames.length; i++) {
            if (parentNames[i].indexOf(role) > -1 && parentNames[i].indexOf(target) > -1) return i;
        }
        for (var j = 0; j < parentNames.length; j++) {
            if (parentNames[j].indexOf(target) > -1) return j;
        }
        return -1;
    }

    function setIfChanged(el, text) {
        if (el && el.textContent !== text) el.textContent = text;
    }

    function renderOne(wrap) {
        var parts = parseAttr(wrap, 'data-parts');
        var parentOptions = parseAttr(wrap, 'data-parent-options');
        if (!parts || !parentOptions) return;

        var picker = pickerFor(wrap);
        if (!picker) return;

        var values = selectedValues(picker);
        if (!values) return;

        var parentNames = parentOptions.map(function (n) { return (n || '').toLowerCase(); });

        parts.forEach(function (part, idx) {
            var row = wrap.querySelector('[data-bundle-part="' + idx + '"]');
            if (!row || !part.variants || !part.variants.length) return;

            var wanted = (part.options || []).map(function (name) {
                var i = indexFor(parentNames, name, part.role);
                return i > -1 ? values[i] : null;
            });

            var match = part.variants.filter(function (v) {
                return wanted.every(function (val, i) {
                    return val === null || v.options[i] === val;
                });
            })[0];

            setIfChanged(row.querySelector('[data-part-sku]'), match && match.sku ? match.sku : '-');
            setIfChanged(row.querySelector('[data-part-price]'), match ? ' (' + Shopify.formatMoney(match.price, window.money_format) + ')' : '');
        });
    }

    function renderAll() {
        document.querySelectorAll('[data-bundle-parts]').forEach(renderOne);
    }

    function init() {
        renderAll();

        document.addEventListener('change', function () { setTimeout(renderAll, 50); }, true);

        var timer;
        new MutationObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(renderAll, 120);
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();